export default {
  StateOfTexasLogoAlt: 'State of Texas Logo',
  Copyright: `Copyright &copy; ${new Date().getFullYear()} State of Texas. All rights reserved.`,
  CallSupport: `Contact your organization for support`,
};
